/* src/app/components/ApproveTable/styles.js */

export default theme => ({
  root: {
    position: 'relative',
  },
  header: {
    height: theme.spacing.unit * 5,
  },
  cell: {
    textAlign: 'center',
    paddingLeft: 0,
    paddingRight: 0,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/ApproveTable/styles.js